import locationCustomer from './locationCustomer';

export default {
	locationCustomerPage: locationCustomer
}